import { Leaf } from "@phosphor-icons/react";
import { DIET_LABELS, SHORT_LABELS } from "@/lib/diets";

// Diet chips for the diets present in the current results; ticked diets combine (ALL must match).
export const DietFilterChips = ({ items, filters, onChange }) => {
  const sel = filters.diets || [];
  const base = items.filter((it) => sel.every((d) => (it.diet_badges || []).includes(d)));
  const counts = Object.keys(DIET_LABELS).map((d) => [d, sel.includes(d) ? base.length : base.filter((it) => (it.diet_badges || []).includes(d)).length]);
  const shown = counts.filter(([d, n]) => n > 0 || sel.includes(d));
  if (!shown.length) return null;
  const toggle = (d) => onChange({ ...filters, diets: sel.includes(d) ? sel.filter((x) => x !== d) : [...sel, d] });
  return (
    <div className="flex flex-wrap items-center gap-1.5 mb-6 -mt-3" data-testid="search-diet-filters">
      <span className="text-[11px] uppercase tracking-wider font-bold text-rf-ink-soft mr-1 inline-flex items-center gap-1">
        <Leaf size={12} weight="fill" className="text-emerald-700" aria-hidden="true" /> Diet:
      </span>
      {shown.map(([d, n]) => {
        const on = sel.includes(d);
        return (
          <button key={d} type="button" aria-pressed={on} data-testid={`search-diet-${d}`} onClick={() => toggle(d)} title={DIET_LABELS[d]}
            className={`px-3 py-1.5 rounded-full text-xs font-bold border transition-colors ${on ? "bg-emerald-700 text-white border-emerald-700" : "bg-white text-rf-ink-soft border-rf-ink/15 hover:border-emerald-700/50"}`}>
            {SHORT_LABELS[d]} ({n})
          </button>
        );
      })}
      {sel.length > 0 && (
        <button type="button" data-testid="search-diet-clear" onClick={() => onChange({ ...filters, diets: [] })} className="text-xs font-bold text-rf-ink-soft underline ml-1 hover:text-rf-ink">
          Clear diets
        </button>
      )}
    </div>
  );
};
